import React from "react";

interface MyStatsProps {
  onClose: () => void;
}

const MyStats: React.FC<MyStatsProps> = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-slate-900 z-50 overflow-y-auto">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-3xl font-bold text-white">My Stats</h1>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-white text-2xl"
          >
            ×
          </button>
        </div>
        <div className="bg-slate-800 rounded-xl p-12 text-center border border-slate-700">
          <div className="text-6xl mb-4">📊</div>
          <h3 className="text-xl font-semibold mb-2 text-white">Stats coming soon</h3>
          <p className="text-slate-400 text-sm">
            Player career statistics will be available in a future update.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MyStats;
